import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IUserProfile } from "../../../shared/oversight-core/interfaces/user-profile";
import { RootState } from "../../store";

type UserState = {
  profile?: IUserProfile;
  country: string;
};

const initialState: UserState = {
  profile: undefined,
  country: localStorage.getItem("country") || "",
};

export const userSlice = createSlice({
  name: "user",
  initialState: { ...initialState },
  reducers: {
    setProfile: (state, action: PayloadAction<IUserProfile>) => {
      state.profile = action.payload;
    },
    resetProfile: (state) => {
      state.profile = undefined;
    },
    setCountry: (state, action: PayloadAction<string>) => {
      state.country = action.payload;
      localStorage.setItem("country", action.payload);
    },
  },
});

export const { setProfile, resetProfile, setCountry } = userSlice.actions;

export const selectProfile = (state: RootState) => state.user.profile;

export const selectCountry = (state: RootState) => state.user.country;

export default userSlice.reducer;
